import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=564772f4&scoped=true&lang=pug&"
import script from "./Back.vue?vue&type=script&lang=js&"
export * from "./Back.vue?vue&type=script&lang=js&"
import style0 from "./Back.scss?vue&type=style&index=0&id=564772f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564772f4",
  null
  
)

export default component.exports